module.exports = __webpack_public_path__ + "img/duanwu_ps_26.6841cbf1.jpg";